export const START_NODE_TYPE = 'start';
export const SCREEN_NODE_TYPE = 'screen';
export const INTERGRATION_NODE_TYPE = 'integration';
export const ACTION_NODE_TYPE = 'action';
export const END_NODE_TYPE = 'end';
export const CONNECTION = 'connection';
